import { render, staticRenderFns } from "./tab-item.vue?vue&type=template&id=763c512a&"
import script from "./tab-item.vue?vue&type=script&lang=js&"
export * from "./tab-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports